// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-tpV","option":"styles_option__3CVB2","selected":"styles_selected__Vhtbh"};